export class TranslateEmailTemplate {
  idTranslateEmailTemplate: number;
  idEmailTemplate: number;
  idLanguage: number;
  subject: string;
  body: string;
  bodyHtml: string;
  locked: boolean;

  constructor(
    idTranslateEmailTemplate: number,
    idEmailTemplate: number,
    idLanguage: number,
    subject: string,
    body: string,
    bodyHtml: string,
    locked: boolean,
  ) {
    this.idTranslateEmailTemplate = idTranslateEmailTemplate;
    this.idEmailTemplate = idEmailTemplate;
    this.idLanguage = idLanguage;
    this.subject = subject;
    this.body = body;
    this.bodyHtml = bodyHtml;
    this.locked = locked;
  }

  static fromRaw(raw: any): TranslateEmailTemplate {
    return new TranslateEmailTemplate(
      Number(raw.idTranslateEmailTemplate),
      Number(raw.idEmailTemplate),
      Number(raw.idLanguage),
      String(raw.subject),
      String(raw.body),
      String(raw.bodyHtml),
      Boolean(raw.locked),
    );
  }

  clone(): TranslateEmailTemplate {
    return new TranslateEmailTemplate(
      this.idTranslateEmailTemplate,
      this.idEmailTemplate,
      this.idLanguage,
      this.subject,
      this.body,
      this.bodyHtml,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idEmailTemplate: this.idEmailTemplate,
      idLanguage: this.idLanguage,
      subject: this.subject,
      body: this.body,
      bodyHtml: this.bodyHtml,
    };
    if (this.idTranslateEmailTemplate !== 0) {
      payload.idTranslateEmailTemplate = this.idTranslateEmailTemplate;
    }
    return payload;
  }
}
